import dataModel from '../../models/DataModel.js';
import marketsService from '../../services/marketsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const markets_root = {
  markets: {},
};

export default class MarketsCollection extends AOCollection {
  constructor(userId, companyId) {
    super({
      name: ReduxConstants.MARKETS,
      collectionType: ReduxConstants.MARKET,
      userId,
      companyId, 
    });
  }

  static build(userId, companyId) {
    let collection = new MarketsCollection(userId, companyId);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection.markets);
    });
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    // console.log(options)
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        // Get everything we already got
        if (shouldPaginate) {
          this.page = 1;
          if (collection && collection.perPage) {
            this.perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
            
        let serviceCall = marketsService.getAllMarkets.bind(this, localStorage.current_company_id, options);

        let newCollection = await this._fetchData(serviceCall, options);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
    
        return resolve(newCollection.markets);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/MarketsCollection.js